/**
 * KAN-980 / KAN-979: раздел "Платформа" (только суперпользователь): кабинеты
 * с ручной корректировкой кошелька и пул Telegram-аккаунтов.
 */
import { PageLayout } from '@/components/layout';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';
import { CabinetsTab } from '@/components/platform/CabinetsTab';
import { TgPoolTab } from '@/components/platform/TgPoolTab';

export function PlatformPage() {
  return (
    <PageLayout title="Платформа">
      <Tabs defaultValue="cabinets">
        <TabsList>
          <TabsTrigger value="cabinets">Кабинеты</TabsTrigger>
          <TabsTrigger value="tg-pool">Пул Telegram</TabsTrigger>
        </TabsList>
        <TabsContent value="cabinets">
          <CabinetsTab />
        </TabsContent>
        <TabsContent value="tg-pool">
          <TgPoolTab />
        </TabsContent>
      </Tabs>
    </PageLayout>
  );
}
